
export default function AboutHero() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Committed to Protecting 
              <span className="text-red-600"> Lives & Property</span>
            </h1>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              FlameGuardQA is a leading fire and safety company based in Qatar, delivering end-to-end 
              fire protection and prevention solutions. We specialize in the design, supply, installation, 
              testing, and maintenance of fire alarm, firefighting, and emergency systems — fully compliant 
              with QCDD standards.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our mission is simple: to safeguard lives, assets, and communities through world-class 
              fire safety technology and reliable service.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20team%20in%20Qatar%20wearing%20safety%20helmets%20and%20uniforms%2C%20standing%20in%20front%20of%20modern%20fire%20protection%20equipment%20including%20fire%20alarm%20panels%20and%20extinguishers%2C%20clean%20industrial%20setting%20with%20red%20safety%20equipment%2C%20technical%20expertise%20demonstration&width=600&height=500&seq=about-hero&orientation=landscape"
              alt="FlameGuardQA Professional Team"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -right-6 bg-red-600 text-white p-6 rounded-xl shadow-lg">
              <div className="w-8 h-8 flex items-center justify-center mb-2">
                <i className="ri-award-line text-2xl"></i>
              </div>
              <p className="font-bold">QCDD Certified</p>
              <p className="text-sm opacity-90">Trusted Partner</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}